import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Sidebar from '../components/Sidebar';
import BulkOpeningStockImport from '../components/BulkOpeningStockImport';
import { canSetStartingValue } from '../utils/inventoryStartingValueForm';

const InventoryStartingValueBulkImport = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!canSetStartingValue()) {
      navigate('/inventory', { replace: true });
    }
  }, [navigate]);

  if (!canSetStartingValue()) {
    return null;
  }

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-shrink-0 px-6 pt-6 pb-0">
          <Link
            to="/inventory"
            className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="h-4 w-4 mr-1.5" />
            Back to Inventory
          </Link>
        </div>
        <BulkOpeningStockImport />
      </div>
    </div>
  );
};

export default InventoryStartingValueBulkImport;
